import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsumidorLoginComponent } from '../../restrito/consumidor';
import { CidadaoLgpd } from '../../restrito/consumidor/consumidor-lgpd/cidadao-lgpd';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute) {
  }

  onClickMenu(rota) {

    const sessionEdit = sessionStorage.getItem('editMode');

    if(sessionEdit == null) {

      this.router.navigate([rota]);

    }else {

      if(!CidadaoLgpd.TermoLgpdAceito()) {

        this.router.navigate(['/consumidor/termo-lgpd']);

      }else{

        this.router.navigate([rota]);
        
      }
    }
   
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-layout/header/header.component.ts